import { Module } from 'vuex';
import * as firebase from 'firebase/app';
import 'firebase/firestore';
import { getRegionName } from '@/utils/functionsRegion';

const zendeskModule: Module<any, any> = {
  namespaced: false,
  state: {
    userId: null,
    orgId: null,
    redirectUrl: null
  },

  mutations: {
    setUserId(state: any, payload: []) {
      state.userId = payload;
    },

    setOrgId(state: any, payload: []) {
      state.orgId = payload;
    },

    setRedirectUrl(state: any, payload: []) {
      state.redirectUrl = payload;
    }
  },

  actions: {

    async upsertUser({ commit }) {
      const upsertUser = firebase.app().functions(getRegionName()).httpsCallable("zendesk-upsertUser");
      const upsertUserResponse = await upsertUser({
        email: this.state.authModule.user.email,
        name: this.state.authModule.user.name,
        externalId: this.state.authModule.user.id,
        organizationName: this.state.authModule.currentFacilityData.name,
        role: 'end-user',
        facilityId: this.state.authModule.currentFacility
      });

      if (upsertUserResponse.data.success) {
        console.log('user: ', upsertUserResponse.data.data.user.id)
        commit('setUserId', upsertUserResponse.data.data.user.id)
      } else {
        console.error("Failed to create/update user:", upsertUserResponse.data.error);
      }
    },

    async getOrg({ commit }) {
      const getOrgQuery = firebase.app().functions(getRegionName()).httpsCallable("zendesk-getOrg");
      const getOrgResponse = await getOrgQuery({
        hubspotId: this.state.authModule.currentFacilityData.refId,
        facilityId: this.state.authModule.currentFacility
      });

      if (getOrgResponse.data.success) {
        console.log("Org successfully got:", getOrgResponse.data.data);
        commit('setOrgId', getOrgResponse.data.data)
      } else {
        console.error("Failed to get org:", getOrgResponse.data.error);
      }
    },

    async mapUserToOrg() {
      const mapUserToOrg = firebase.app().functions(getRegionName()).httpsCallable("zendesk-mapUserToOrg");
      const mapUserToOrgResponse = await mapUserToOrg({
        userId: this.state.zendeskModule.userId,
        orgId: this.state.zendeskModule.orgId,
        facilityId: this.state.authModule.currentFacility
      });

      if (mapUserToOrgResponse.data.success) {
        console.log("Successfully mapped:", mapUserToOrgResponse.data.data);
      } else {
        console.error("Failed to map user to org:", mapUserToOrgResponse.data.error);
      }
    },

    async getZendeskRedirectUrl({ commit }) {
      return firebase.app().functions(getRegionName()).httpsCallable("zendesk-getSSOJWT")({
        user: this.state.authModule.user,
        facilityId: this.state.authModule.currentFacility
      }).then((res) => {
        console.log(res.data.redirectUrl)
        commit('setRedirectUrl', res.data.redirectUrl)
      }).catch((error) => {
        console.error(error);
      })
    },
  }
};
export default zendeskModule;
